import { handleActions } from 'redux-actions';
import { NOTIFICATION } from './actions';
import { REDUX_NOTIFICATION_TYPES } from './index';

const initialState = {
  timeout: 5, //in seconds,
  show: false,
  type: REDUX_NOTIFICATION_TYPES.INFO,
};

export const reduxNotificationReducer = handleActions(
  {
    [NOTIFICATION]: (prevState, { payload: { message, timeout, show, type } }) => {
      if (!show) {
        return initialState;
      }
      return {
        ...prevState,
        message: message,
        timeout: timeout || prevState.timeout,
        show: show,
        type: type || prevState.type,
      };
    },
  },
  initialState
);
